module.exports = __webpack_public_path__ + "img/fangtan2-2.4c667aff.png";